module.exports = __webpack_public_path__ + "static/media/STARTIMES.bcd3f066.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/STARTIMES.svg
// module id = 385
// module chunks = 25